import { AfterViewInit, Component, TemplateRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { Config } from "../../config.const";
import { EmailService } from "../../email.service";

@Component({
    selector: 'app-email',
    templateUrl: './email.html'
})
export class EmailComponent implements AfterViewInit {

    @ViewChild('loading')
    loading: TemplateRef<any>;

    modalRef: any

    showErrorBox: boolean = false
    showInfoBox: boolean = false
    message: string

    changing: Subscription;
    formGroup = new FormGroup({
        email: new FormControl(),
        email2: new FormControl(),
    });

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private emailService: EmailService,
        public readonly activeModal: NgbActiveModal
    ) { }

    ngAfterViewInit() {
        setTimeout(() => {
            this.get()            
        }, 500);
    }

    /**
     * Estrae l'e-mail del medico per il recupero password
     */
    async get() {
        this.showErrorBox = false
        this.showInfoBox = false

        this.modalRef = this.modalService.open(
            this.loading,
            { backdrop: 'static' }
        );

        try {
            const response = await this.emailService.get()

            if (response.success) {
                this.formGroup.get('email').setValue(response.data.email)
                this.formGroup.get('email2').setValue(response.data.email)
            } else {
                this.showErrorBox = true
            }
            this.message = response.message

        } catch (err) {
        } finally {
            this.modalRef.close();
        }
    }

    async confirm() {

        this.showErrorBox = false
        this.showInfoBox = false

        const modalRef = this.modalService.open(
            this.loading,
            { backdrop: 'static' }
        );

        try {
            const request = await fetch(`${Config.baseURL}/email`, {
                method: 'POST',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.formGroup.getRawValue())
            });
            const response = await request.json()

            if (response.success) {
                this.showInfoBox = true
                this.modalRef.close()
                this.activeModal.close()
            } else {
                this.showErrorBox = true
            }
            this.message = response.message

        } catch (err) {
        } finally {
            modalRef.close();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/opzioni/email/email.ts